import { z } from 'zod';
import { requiredString, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет содержание текстовки */
export const messageTemplateSchema = z.object({
    text: textWithinLimit(4000, 'Не более 4000 символов')
        .pipe(requiredString('Введите текст сообщения', {
            trim: false,
            rejectWhitespace: true,
        })),
    description: textWithinLimit(1000, 'Пояснение: не более 1000 символов'),
});

/** Поля редактирования текстовки */
export type MessageTemplateFormValues = z.infer<typeof messageTemplateSchema>;
